(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-carousel"] && !Shopify.designMode) return;
  try {
    class ProductRecsCarousel extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;

      this.track = this.querySelector('[data-carousel-track]');
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');

      if (!this.track) return;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.track.scrollLeft = 0;

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevBtn?.addEventListener('click', () => this.scrollToIndex(this.getNearestIndex() - 1));
      this.nextBtn?.addEventListener('click', () => this.scrollToIndex(this.getNearestIndex() + 1));

      // Watches the block itself, not just window resize — matters in the
      // Horizon theme editor, where the preview frame resizes independently.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      requestAnimationFrame(() => this.updateArrowState());
    }

    disconnectedCallback() {
      this._connected = false;
      this.track?.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', this.onResize);
      }
    }

    getCards() {
      return Array.from(this.track.children).filter((el) => el.classList.contains('product-recs-carousel__card'));
    }

    getCardLeft(card) {
      const trackRect = this.track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      return this.track.scrollLeft + cardRect.left - trackRect.left;
    }

    getNearestIndex() {
      const cards = this.getCards();
      if (!cards.length) return 0;
      const current = this.track.scrollLeft;
      let nearestIndex = 0;
      let nearestDistance = Infinity;
      cards.forEach((card, index) => {
        const distance = Math.abs(this.getCardLeft(card) - current);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      return nearestIndex;
    }

    // Scrolls to the real rendered position of the target card
    // (offsetLeft-derived), not a fixed cardWidth + gap distance — stays
    // accurate across breakpoints, card-size settings, and gap changes.
    scrollToIndex(index) {
      const cards = this.getCards();
      if (!cards.length) return;
      const targetIndex = Math.max(0, Math.min(cards.length - 1, index));
      const target = cards[targetIndex];
      this.track.scrollTo({ left: this.getCardLeft(target), behavior: 'smooth' });
    }

    onScroll() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => this.updateArrowState());
    }

    onResize() {
      requestAnimationFrame(() => this.updateArrowState());
    }

    updateArrowState() {
      if (!this.prevBtn || !this.nextBtn || !this.track) return;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const current = Math.max(0, this.track.scrollLeft);
      const tolerance = 3;
      this.prevBtn.disabled = current <= tolerance;
      this.nextBtn.disabled = maxScroll <= tolerance || current >= maxScroll - tolerance;
    }
  }

  if (!customElements.get('product-recs-carousel')) {
    customElements.define('product-recs-carousel', ProductRecsCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
